import React, { useRef } from 'react'
import Dialog from 'material-ui/Dialog'
import { useEffect, useState } from 'react'
import {
    Box,
    Card,
    TextField,
    Typography,
    Checkbox,
    FormControlLabel,
    Button,
    InputAdornment,
    Snackbar,
    Alert,
    Stack
} from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { glasConfig } from '../../../constants/Config';
import * as SettingMenuPremiumAction from '../../../actions/SettingMenuPremium'
import { connect } from "react-redux";
import { NumericFormat } from 'react-number-format';
export const ModalSettingMenuPremiumEdit = (props) => {

    const [checked, setChecked] = useState(true)
    const [messageServerError, setMessageServerError] = useState('')
    const [openSnackbar, setOpenSnackbar] = useState(false)
    const [isShow, setShow] = useState(false)
    const [formData, setFormData] = useState({
        menuName: '',
        price: 0,
        description: '',
        deliveryItem: '',
    });

    const submitBtnRef = useRef(false);
    const [errors, setErrors] = useState({});

    const handleCheckboxChange = () => {
        setChecked(prev => !prev);
    };

    const handleCloseSnackbar = () =>{
        setOpenSnackbar(false)
    }
    const handleInputChange = (field, maxLength) => (event) => {
        const value = event.target.value;
        const trimmedValue = maxLength ? value.slice(0, maxLength) : value;
        setFormData(prev => ({ ...prev, [field]: trimmedValue }));
        setErrors(prev => {
            const newErrors = { ...prev };
            if (newErrors[field] && trimmedValue.trim()) {
                delete newErrors[field];
            }
            return newErrors;
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (submitBtnRef.current) submitBtnRef.current.disabled = true;

        const dispatch = props.dispatch;
        let newErrors = {};
        if (!formData.menuName.trim()) newErrors.menuName = 'メニュー名を入力してください';
        if (!formData.description.trim()) newErrors.description = '説明を入力してください';
        if (checked && !formData.deliveryItem.trim()) newErrors.deliveryItem = '納品物を記入してください';
        if (!formData.price){
            newErrors.price = 'メニュー名を入力してください';
        } else if(formData.price < 500 || formData.price > 6000) {
            newErrors.price = '500〜6,000ptsの間で設定可能';
        }
        if (Object.keys(newErrors).length) {
            setErrors(newErrors);
            if (submitBtnRef.current) submitBtnRef.current.disabled = false;
            return;
        }

        let data = {
            application: glasConfig.application,
            title: formData.menuName,
            description: formData.description.trim(),
            amount:formData.price,
            is_deliverable: checked,
            deliverable_note: formData.deliveryItem
        }
        try {
            const response = await dispatch(SettingMenuPremiumAction.putMenuPremium(data, props.data.id));
            if (response.code === 0) {
                await props.dispatch(SettingMenuPremiumAction.getAllMenuPremium())
                props.resetToggle()
            } else {
                setOpenSnackbar(true);
                setMessageServerError(response.message)
            }
        } catch (error) {
            setOpenSnackbar(true)
        }finally {
            if (submitBtnRef.current) submitBtnRef.current.disabled = false;
        }

    };
    const isFormValid = () => {
        const { menuName, price, description, deliveryItem } = formData;
        return (
            menuName.trim() !== '' &&
            price > 0 &&
            description.trim() !== '' &&
            (!checked || deliveryItem.trim() !== '')
        );
    };

    useEffect(() => {
        setShow(props.isShow)
    }, [props.isShow])

    useEffect(() => {
        if (props.data) {
            if(props.data.is_deliverable){
                setChecked(true)
            }else{
                setChecked(false)
            }
            setFormData((prev) => ({
                ...prev,
                menuName: props.data.title || '',
                price : props.data.amount || '',
                description : props.data.description || '',
                deliveryItem : props.data.deliverable_note || '',
            }));

        }
    }, [props.data]);

    const closeDialog = () => setShow(true)

    const onCancel = () => {
        closeDialog()
        props.resetToggle()
    }
    return (

        <div>
            <Dialog
                modal={false}
                open={isShow}
                bodyClassName="modal-missing__profile setting-popup-overflow"
                contentClassName="setting-popup-menu-premium"
            >
                <div className="cancel-dialog__right">
                    <span onClick={() => onCancel()}>X</span>
                </div>
                <div className="modal-missing__profile-content" id="content-appeal__message">
                    <div className="setting-create-menu-form" style={{ margin: '0', boxShadow: 'none', border: 'none' }}>
                        <h4 style={{ textAlign: 'center', fontWeight: '700', color:'#11ad9d', marginBottom:'15px' }}>
                            プレミアムメニューの修正
                        </h4>
                        <form onSubmit={handleSubmit}>
                            <div className='menu-premium-grid-form'>
                                <div>
                                    <label  className='color_label'>メニュー名</label>
                                    <Box sx={{ mb: 2 }}>
                                        <TextField
                                            variant="standard"
                                            fullWidth
                                            value={formData.menuName}
                                            onChange={handleInputChange('menuName',20)}
                                            error={!!errors.menuName}
                                            helperText={errors.menuName ||
                                                <Box component="span" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    {formData.menuName.length}/20
                                                </Box>
                                            }
                                        />
                                    </Box>
                                </div>
                                <div>
                                    <label className='color_label'>金額</label>
                                    <Box sx={{ mb: 2 }}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <NumericFormat
                                                id="price-input"
                                                customInput={TextField}
                                                value={formData.price}
                                                thousandSeparator={true}
                                                suffix=" pts"
                                                allowNegative={false}
                                                valueIsNumericString={true}
                                                variant="standard"
                                                fullWidth
                                                decimalScale={0}
                                                placeholder=" pts"
                                                InputProps={{
                                                    endAdornment: (
                                                        <Typography variant="caption" color="error" sx={{ whiteSpace: 'nowrap' }}>
                                                            獲得: {Math.floor((formData.price || 0) * props.pointRatio.returning_customer_ratio / 100).toLocaleString()}
                                                        </Typography>
                                                    )
                                                }}
                                                helperText={
                                                    errors.price ? (
                                                        <Box component="span" sx={{ color: 'error.main' }}>
                                                            {errors.price}
                                                        </Box>
                                                        ) : (
                                                        <Box component="span" sx={{ display: 'flex', justifyContent: 'flex-end', color: 'text.secondary' }}>
                                                            500〜6,000ptsの間で設定可能
                                                        </Box>
                                                        )
                                                }
                                                onValueChange={(values) => {
                                                    const { floatValue } = values;
                                                    handleInputChange('price')({ target: { value: floatValue !== undefined ? floatValue : null } });
                                                }}
                                                isAllowed={(values) =>
                                                    values.floatValue === undefined || (values.floatValue >= 0 && values.floatValue <= 6000)
                                                }
                                            />
                                        </Stack>
                                    </Box>
                                </div>
                            </div>
                            <div className='menu-premium-grid-form'>
                                <div>
                                    <label  className='color_label'>説明</label>
                                    <Box sx={{ mb: 2 }}>
                                        <TextField
                                            variant="standard"
                                            multiline
                                            rows={3}
                                            fullWidth
                                            value={formData.description}
                                            onChange={handleInputChange('description',140)}
                                            error={!!errors.description}
                                            helperText={errors.description ||
                                                <Box component="span" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    {formData.description.length}/140
                                                </Box>
                                            }
                                        />
                                    </Box>
                                </div>
                                <div>
                                    <Box sx={{ mb: 2 }}>
                                        <Typography sx={{ fontWeight: '100' }}  className='color_label'>納品物</Typography>
                                        <FormControlLabel
                                            control={<Checkbox checked={!checked} onChange={handleCheckboxChange} />}
                                            label="なし"
                                            componentsProps={{
                                                typography: {
                                                    sx: { fontWeight: 400 }
                                                }
                                            }}
                                        />
                                        <FormControlLabel
                                            control={<Checkbox checked={checked} onChange={handleCheckboxChange} />}
                                            label="あり"
                                            componentsProps={{
                                                typography: {
                                                    sx: { fontWeight: 400 }
                                                }
                                            }}
                                        />
                                        {checked && <TextField
                                            fullWidth
                                            variant="standard"
                                            size="small"
                                            placeholder="納品物をお書きください"
                                            value={formData.deliveryItem}
                                            error={!!errors.deliveryItem}
                                            helperText={errors.deliveryItem ||
                                                <Box component="span" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    {formData.deliveryItem.length}/16
                                                </Box>}
                                            inputProps={{
                                                maxLength: 16, sx: {
                                                    '&::placeholder': {
                                                        fontSize: '12px'
                                                    },
                                                },
                                            }}
                                            onChange={handleInputChange('deliveryItem', 16)}
                                            sx={{ mt: 1 }}
                                        />}

                                        <Typography className='color_label' variant="caption" sx={{ display: 'block', mt: 0.5 }}>
                                            ※メニューの完了を示すことができるものをご提示できる場合「あり」にチェックを入れ記入してください。<br></br>
                                            例: 実施の様子を写真あるいはテキストに起こしたもの
                                        </Typography>
                                    </Box>
                                </div>
                            </div>
                            <Box sx={{ mb: 3, bgcolor: '#f9f9f9', p: 2, borderRadius: 2 }}>
                                <Typography variant="h6" color="error" gutterBottom align="center" style={{ fontWeight: 700 }}>
                                    注意事項
                                </Typography>
                                <Typography variant="body2" component="div">

                                    <p>	このメニュー機能はStella内でのサブコンテンツとなります。占い師の皆さまには、メニューの実施だけでなくユーザー様とのコミュニケーションを大切にしていただきますようお願いいたします。</p>
                                    <p>また、このメニュー機能で獲得したポイントはランキングイベントやミッションの達成条件には反映されず、占い師のランキングにも影響しません。</p>

                                    <h5>1. 承認されないメニュー</h5>
                                    <p>以下のようなメニューは承認されません。</p>

                                    <ul>
                                        <li>身体に影響を与えるメニュー（例：体調が良くなる、身体が軽くなる）</li>
                                        <li>モノに対する施術（例：家の環境を整える）</li>
                                        <li>他人に害を与える内容（例：呪い）</li>
                                        <li>占いとは無関係な内容、あるいは占い師としての技術を伝える内容（例：◯◯についての鑑定方法を教える）</li>
                                        <li>グッズの販売や発送を伴うメニュー（例：念を込めたパワーストーンを送る）</li>
                                        <li>利用規約に反する内容</li>
                                        <li>その他、Stella運営事務局が不適切だと判断した内容</li>
                                    </ul>

                                    <h5>2. 禁止行為</h5>
                                    <p>以下のような行為は禁止しています。違反した場合、ポイントの没収やアカウント停止となる場合があります。</p>
                                    <ul>
                                        <li>
                                            占い師からユーザー様に対して、メニューの申し込みを促す営業行為を行うこと。
                                        </li>
                                        <li>一つのメニューを繰り返し申し込むことを推奨する、あるいは他のメニューも合わせて申し込むように勧めること。</li>
                                        <li>施術やコンテンツのみを提供し、ユーザー様とのコミュニケーションを行わないこと。</li>
                                        <li>メニューに記載の金額以上のポイントを請求すること</li>
                                        <li>利用規約に反する行為</li>
                                    </ul>
                                    <h5>3. メニュー提供に関するルール</h5>
                                    <p>ユーザー様のメニュー申込後、7日以内に占い師から連絡がなかった場合、ユーザー様へのポイント返還（＝占い師からのポイント没収）の対象となる場合があります。</p>
                                    <p>また、メニュー進行中に占い師との連絡が途絶え、メニューが中断された場合も、ユーザー様へのポイント返還（＝占い師からのポイント没収）の対象となる場合があります。</p>
                                    <p>メニューの完了を明瞭にするため、「納品物」を「あり」に設定し、メニューの完了時に記載した内容の納品を行うことを推奨します。</p>

                                    <h5>4. 免責事項</h5>
                                    <p>本コンテンツを通じてユーザー様との間にトラブルが発生した場合、Stellaはその責任を負いません</p>
                                </Typography>
                            </Box>
                            <div style={{display:'flex'}}>
                                <Button
                                    onClick={() => onCancel()}
                                    variant="contained"
                                    sx={{ mt: 2 }}
                                    style={{ background: '#f9f9f9', color: '#202020', display: 'flex', margin: '0 auto 50px' }}
                                >
                                    キャンセル
                                </Button>
                                <Button
                                    ref={submitBtnRef}
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 2 }}
                                    style={{ color: '#ffffff', background: isFormValid() ? '#11ad9d' : '#bdbdbd', display: 'flex', margin: '0 auto 50px' , fontWeight: 600}}
                                    disabled={!isFormValid()}
                                >
                                    修正を審査再提出
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>

                <Snackbar
                    open={openSnackbar}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={handleCloseSnackbar} severity="error">
                        {messageServerError}
                    </Alert>
                </Snackbar>
            </Dialog>
        </div>
    )
}
